import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getCities = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/cities`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const getCity = (token, cityId) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/cities/${cityId}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const createCity = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/cities`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const updateCity = (token, id, body) => axios.put(`${VUE_APP_API_URL}/api/v1/admin/cities/${id}`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
export const deleteCity = (token, id) => axios.delete(`${VUE_APP_API_URL}/api/v1/admin/cities/${id}`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
